import React from 'react'
import {
  ClearableInput,
  LocalizedText,
  useQueryParam,
  TableContext,
  isFilterInSentence,
  FilterIcon,
} from 'labguard-cdk'
import { useIntl } from 'react-intl'

const ChannelNameFilter = props => {
  const [name = '', setName] = useQueryParam('name')
  const { useFilter } = TableContext.use()
  const intl = useIntl()

  // register filter
  useFilter({ name: 'name', filter: item => containsName(item, name, intl) }, [name])

  return (
    <ClearableInput
      icon={FilterIcon}
      label={<LocalizedText id="WEB_FILTER_BY_NAME" />}
      color="light"
      value={name}
      onChange={setName}
      {...props}
    />
  )
}

export default ChannelNameFilter

/**
 * Check if a provided name is included in an object name
 * @param {*} item
 * @param {*} name
 * @param {*} intl
 */
function containsName(item, name, intl) {
  const object =
    item.channel || item.device || (item.marker && { name: intl.formatMessage({ id: item.marker.i18n }) }) || item
  return !object.name || isFilterInSentence(name, object.name)
}
